import { Components, Theme } from '@mui/material/styles';

const itemSize = {
  small: {
    minWidth: 26,
    height: 26,
  },
  medium: {
    minWidth: 32,
    height: 32,
  },
  large: {
    minWidth: 40,
    height: 40,
  },
};

export const muiPaginationItemOverride: Components<Theme>['MuiPaginationItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      margin: 0,
      marginRight: theme.spacing(3),
      marginLeft: theme.spacing(3),
      minWidth: itemSize.medium.minWidth,
      height: itemSize.medium.height,
      borderRadius: '100%',
      display: 'flex',
      alignItems: 'center',
      '&.Mui-selected': {
        backgroundColor: theme.vars.palette.primary.light,
        '&:hover': {
          backgroundColor: theme.vars.palette.primary.light,
        },
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    }),
    sizeLarge: {
      minWidth: itemSize.large.minWidth,
      height: itemSize.large.height,
    },
    sizeSmall: {
      minWidth: itemSize.small.minWidth,
      height: itemSize.small.height,
    },
  },
};
